import { resolveSearchExpression } from "./map-search-contract.js";

function isPlainObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

function cloneJson(value) {
  return JSON.parse(JSON.stringify(value));
}

function normalizeLayerClipMasks(value) {
  const source = isPlainObject(value) ? value : {};
  const next = {};
  for (const [layerIdRaw, maskLayerIdRaw] of Object.entries(source)) {
    const layerId = String(layerIdRaw ?? "").trim();
    const maskLayerId = String(maskLayerIdRaw ?? "").trim();
    if (!layerId || !maskLayerId || layerId === maskLayerId) {
      continue;
    }
    next[layerId] = maskLayerId;
  }
  return next;
}

export function hasActiveZoneSearchFilters(filters) {
  const source = isPlainObject(filters) ? filters : {};
  return expressionHasZoneSearchTerm(resolveSearchExpression(source.searchExpression));
}

function expressionHasZoneSearchTerm(node) {
  if (!isPlainObject(node)) {
    return false;
  }
  if (node.type === "term") {
    const term = isPlainObject(node.term) ? node.term : {};
    switch (term.kind) {
      case "fish":
      case "item":
      case "item-group":
      case "status":
      case "grade":
      case "zone":
        return true;
      case "semantic":
        return String(term.layerId ?? "").trim() === "zone_mask";
      default:
        return false;
    }
  }
  if (node.type === "group" && Array.isArray(node.children)) {
    return node.children.some((child) => expressionHasZoneSearchTerm(child));
  }
  if (node.type === "container") {
    return expressionHasZoneSearchTerm(node.expression);
  }
  return false;
}

export function buildLayerSearchEffects(filters) {
  const source = isPlainObject(filters) ? filters : {};
  const activeZoneSearch = hasActiveZoneSearchFilters(source);
  const effectiveLayerClipMasks = normalizeLayerClipMasks(source.layerClipMasks);

  return {
    activeZoneSearch,
    effectiveLayerClipMasks: cloneJson(effectiveLayerClipMasks),
  };
}
